/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Na_Plan_GeneratingInputs */

const en_inbox_na_plan_generating = /** @type {(inputs: Inbox_Na_Plan_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Composing…`)
};

const id_inbox_na_plan_generating = /** @type {(inputs: Inbox_Na_Plan_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang menyusun…`)
};

/**
* | output |
* | --- |
* | "Composing…" |
*
* @param {Inbox_Na_Plan_GeneratingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_plan_generating = /** @type {((inputs?: Inbox_Na_Plan_GeneratingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_Plan_GeneratingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_plan_generating(inputs)
	return en_inbox_na_plan_generating(inputs)
});